import React, { useState } from 'react';
import { Upload, X, User } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ImageUpload = ({ value, onChange, disabled = false }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      processFile(file);
    }
  };

  const processFile = (file) => {
    if (!file.type.startsWith('image/')) {
      alert('Por favor selecciona una imagen válida');
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      onChange(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!disabled) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    
    if (disabled) return;
    
    const file = e.dataTransfer.files?.[0];
    if (file) {
      processFile(file);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    onChange(null);
  };

  return (
    <div className="w-full">
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={disabled}
        className="hidden"
        id="image-upload"
      />
      
      {value ? (
        <div className="relative group">
          <div className="relative w-full aspect-square max-w-xs mx-auto rounded-xl overflow-hidden border-4 border-brand-200 shadow-lg">
            <img
              src={value}
              alt="Preview"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-200 flex items-center justify-center">
              <Button
                type="button"
                variant="destructive"
                size="sm"
                onClick={handleRemove}
                disabled={disabled}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <X className="w-4 h-4 mr-2" />
                Eliminar
              </Button>
            </div>
          </div>
          <label
            htmlFor="image-upload"
            className={`mt-3 block text-center text-sm text-brand-600 hover:text-brand-700 font-medium ${
              disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
            }`}
          >
            Cambiar foto
          </label>
        </div>
      ) : (
        <label
          htmlFor="image-upload"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className={`
            relative block w-full aspect-square max-w-xs mx-auto
            border-2 border-dashed rounded-xl
            transition-all duration-200
            ${isDragging 
              ? 'border-brand-500 bg-brand-50' 
              : 'border-gray-300 bg-gray-50 hover:bg-gray-100'
            }
            ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
          `}
        >
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6">
            <div className="w-20 h-20 rounded-full bg-brand-100 flex items-center justify-center mb-4">
              {isDragging ? (
                <Upload className="w-10 h-10 text-brand-600" />
              ) : (
                <User className="w-10 h-10 text-brand-600" />
              )}
            </div>
            <p className="text-sm font-medium text-gray-700 text-center mb-1">
              {isDragging ? 'Suelta la imagen aquí' : 'Haz click para subir'}
            </p>
            <p className="text-xs text-gray-500 text-center">
              o arrastra y suelta una imagen
            </p>
            <p className="text-xs text-gray-400 mt-2">
              PNG, JPG, JPEG hasta 5MB
            </p>
          </div>
        </label>
      )}
    </div>
  );
};

export default ImageUpload;
